import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

import { colors } from './colors';

// Token型定義
type TokenValue = { value: string };
type TokenObject = { [key: string]: TokenValue | TokenObject };

// Convert color object to token format
const convertToTokens = (obj: string | Record<string, unknown>): TokenValue | TokenObject => {
  if (typeof obj === 'string') {
    return { value: obj };
  }
  if (typeof obj === 'object' && obj !== null) {
    const result: TokenObject = {};
    for (const key in obj) {
      const value = obj[key];
      if (typeof value === 'string' || (typeof value === 'object' && value !== null)) {
        result[key] = convertToTokens(value as string | Record<string, unknown>);
      }
    }
    return result;
  }
  return { value: String(obj) };
};

// Note: Custom button variants are not working in Chakra UI v3 with current setup
// Use inline styles instead (see SignIn/index.tsx and Connect/index.tsx for examples)

// Create theme config
const themeConfig = defineConfig({
  globalCss: {
    'html, body': {
      color: 'brand.gray.600',
      background: 'transparent',
      fontFamily: 'Outfit, sans-serif',
      margin: 0,
      padding: 0,
    },
    'h1, h2, h3, h4, h5, h6': {
      fontFamily: 'Outfit, sans-serif',
    },
    a: {
      cursor: 'pointer',
    },
    '*::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
    },
    '*::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.1)',
    },
    '*::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    },
    '*::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(255, 255, 255, 0.5)',
    },
  },
  theme: {
    keyframes: {
      hover: {
        '0%': { transform: 'translateY(0)' },
        '50%': { transform: 'translateY(-20px)' },
        '100%': { transform: 'translateY(0)' },
      },
      spin: {
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' },
      },
    },
    tokens: {
      colors: {
        brand: convertToTokens(colors.light.brand),
      },
      fonts: {
        body: { value: 'Outfit, sans-serif' },
        heading: { value: 'Outfit, sans-serif' },
      },
      fontSizes: {
        '2xs': { value: '0.625rem' }, // 10px
        xs: { value: '0.75rem' }, // 12px
        sm: { value: '0.875rem' }, // 14px
        md: { value: '1rem' }, // 16px
        lg: { value: '1.125rem' }, // 18px
        xl: { value: '1.25rem' }, // 20px
        '2xl': { value: '1.5rem' }, // 24px
        '3xl': { value: '2rem' }, // 32px
      },
      animations: {
        hover: { value: 'hover 3s infinite' },
        spin: { value: 'spin 2s linear infinite' },
      },
    },
  },
});

// Create and export the system
export const system = createSystem(defaultConfig, themeConfig);
